import React from 'react';

const PricingSection = ({ sellingPrice, discount = 0, formatPrice }) => {
  const hasDiscount = Number(discount) > 0;

  return (
      <div className="flex items-baseline gap-2 mb-1">
        <span className="text-3xl font-bold text-gray-900">
          {formatPrice(sellingPrice)}
        </span>
        {hasDiscount && (
          <span className="text-sm font-semibold text-green-600">
            -{discount}%
          </span>
        )}
      </div>
  );
};

export default PricingSection;
